import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent {

  public show: boolean = false;

  constructor() {

  }

  @Input() isAbsolutePosition: string = 'true';
  @Input() currentPage: string;
}
